import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBypH7GGxXMosl1MNXhWaFjYleANrETgi0",
  authDomain: "invexa-1f194.firebaseapp.com",
  projectId: "invexa-1f194",
  storageBucket: "invexa-1f194.firebasestorage.app",
  messagingSenderId: "230200454388",
  appId: "1:230200454388:web:719bb5edd3eb54f81742a1",
};

// 👇 ESSA LINHA É A CORREÇÃO
export const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);